/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {RecordPayerTaggingPromptDismissalRequest} from '@cash-web/protos/squareup/cash/paychecks/api/v1/paychecks_app_service.pb'
import {RecordPayerTaggingPromptDismissalResponse} from '@cash-web/protos/squareup/cash/paychecks/api/v1/paychecks_app_service.pb'


export const recordPayerTaggingPromptDismissal = (request: RecordPayerTaggingPromptDismissalRequest, options?: CashRequestOptions) => post<RecordPayerTaggingPromptDismissalRequest, RecordPayerTaggingPromptDismissalResponse>("/2.0/cash/record-payer-tagging-prompt-dismissal", request, {...options, rejectOnError: true })